<div class="setup-container h-full bg-[#7CAFE4]">
  <div class="container absolute mt-3 flex items-center justify-between px-4 xs:px-10">
    <img
      class="h-[48px] w-[48px] cursor-pointer items-center text-primary-blue"
      src="assets/images/logo-header-white.svg"
      width="48"
      height="48"
      (click)="onLogoClick()"
    />
  </div>
  <div class="flex h-full justify-center overflow-y-auto px-4 pb-6 pt-20 xs:overflow-visible xs:p-0">
    <div
      class="my-auto rounded-3xl bg-background-white shadow-card xs:my-0 xs:self-center xs:rounded-[48px]"
      [ngClass]="[modalClass(), outerPaddingClass()]"
    >
      <div class="overflow-y-auto" [ngClass]="[innerHeightClass(), innerPaddingClass()]">
        <div [ngClass]="contentPaddingClass()">
          @if (vmSignal().contract?.state === DataState.Loading) {
            <div class="flex h-full items-center justify-center">
              <ng-lottie currentColor class="text-text-blue" [options]="lottieOptions"></ng-lottie>
            </div>
          } @else {
            <router-outlet></router-outlet>
          }
        </div>
      </div>
    </div>
  </div>
</div>
